const ROUTES = {
  CREATE: 'create',
  DETAIL: 'detail',
  EDIT: 'edit',
  LIST: 'list',
  LOGIN: 'login',
  HOME: 'home',
  REGISTRY: 'registry',
}

export function routeCreate(element: string): string[] {
  return [ROUTES.REGISTRY, element, ROUTES.CREATE];
}

export function routeDetail(element: string, id: string): string[] {
  return [ROUTES.REGISTRY, element, id, ROUTES.DETAIL];
}

export function routeEdit(element: string, id: string): string[] {
  return [ROUTES.REGISTRY, element, id, ROUTES.EDIT];
}

export function routeHome(): string[] {
  return [ROUTES.HOME];
}

export function routeList(element: string): string[] {
  return [ROUTES.REGISTRY, element, ROUTES.LIST];
}

export function routeLogin(): string[] {
  return [ROUTES.LOGIN];
}
